import validate from "/codebuild/output/src4219241025/src/sense-us.app/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/codebuild/output/src4219241025/src/sense-us.app/middleware/auth.global.js";
import manifest_45route_45rule from "/codebuild/output/src4219241025/src/sense-us.app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}